/**
 * Flags de build (Vite): use prefixo VITE_ no .env e no painel do deploy.
 * Valores considerados "true": "true", "1", "yes" (case-insensitive).
 */
const truthy = (v) => {
  const s = String(v ?? '').trim().toLowerCase()
  return s === 'true' || s === '1' || s === 'yes'
}

export const hideProducts = truthy(import.meta.env.VITE_HIDE_PRODUCTS)
